import { AfterViewInit, Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoaderComponent } from '@core/components/global-loader/global-loader.component';
import { AutoResizeService } from '@core/embed/auto-resize.service';
import { MicroappMessagingService } from '@core/messaging/microapp-messaging.service';
import { EmbedModeService } from '@core/runtime/embed-mode.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
})
export class App implements OnInit, AfterViewInit, OnDestroy {
  private readonly embedMode = inject(EmbedModeService);
  private readonly messaging = inject(MicroappMessagingService);
  private readonly autoResize = inject(AutoResizeService);

  protected readonly sessionExpired = this.messaging.sessionExpired;
  protected readonly hasToken = computed(() => !!this.messaging.getAccessToken());

  ngOnInit(): void {
    (window as any).injectMicroappToken = (token: string) => this.messaging.injectToken(token);
  }

  ngAfterViewInit(): void {
    if (!this.embedMode.isEmbedded()) {
      return;
    }

    this.messaging.notifyReady();
    if (!this.hasToken()) {
      this.messaging.requestToken();
    }
    this.autoResize.start();
  }

  ngOnDestroy(): void {
    this.autoResize.stop();
  }

  retryTokenRefresh() {
    this.messaging.requestTokenRefresh();
  }
}
